import debugIt from 'debug'

export const debug = debugIt('sanity:cli')
